import { handleError } from '@/utils/exception_handler';

import api from './api';

export default {

  // Uses FETCH mutations on LOGS
  fetchLogs: (context, args = {}) => {
    const { commit, dispatch } = context;
    const mutationPrefix = 'fetchLogs';

    commit(`${mutationPrefix}Pending`);

    return api.fetchLogs(args)
      .then((response) => {
        dispatch('insert', { data: response.entities });

        commit(`${mutationPrefix}Success`, response.entities);

        return { status: true, data: response };
      }, handleError(context, `${mutationPrefix}Error`))
      .catch(handleError(context, `${mutationPrefix}Error`));
  },

  // Uses FETCH mutations on LOGS
  fetchTimeLogLogs: (context, args = {}) => {
    const { commit, dispatch } = context;
    const mutationPrefix = 'fetchTimeLogLogs';

    commit(`${mutationPrefix}Pending`);

    return api.fetchTimeLogLogs(args)
      .then((response) => {
        dispatch('insert', { data: response.entities });

        commit(`${mutationPrefix}Success`, response.entities);

        return { status: true, data: response };
      }, handleError(context, `${mutationPrefix}Error`))
      .catch(handleError(context, `${mutationPrefix}Error`));
  },

};



// WEBPACK FOOTER //
// ./src/store/modules/log/actions.js